import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2639ea82&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Styles/modal.scss?vue&type=style&index=0&id=2639ea82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639ea82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2639ea82')) {
      api.createRecord('2639ea82', component.options)
    } else {
      api.reload('2639ea82', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=2639ea82&scoped=true&", function () {
      api.rerender('2639ea82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/Modal.vue"
export default component.exports